import React from 'react';
import { Card, Statistic } from 'antd';

const StatCard = ({ title, value, prefix, suffix, color, icon, loading }) => {
  return (
    <Card
      hoverable
      style={{ borderRadius: 12, height: '100%' }}
      styles={{ body: { padding: '20px 24px' } }}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
        <Statistic
          title={<span style={{ fontSize: 14, color: '#8c8c8c' }}>{title}</span>}
          value={value}
          prefix={prefix}
          suffix={suffix}
          loading={loading}
          valueStyle={{ color: color || '#1677ff', fontSize: 28, fontWeight: 600 }}
        />
        {icon && (
          <div style={{
            width: 48,
            height: 48,
            borderRadius: 12,
            background: `${color || '#1677ff'}15`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: 22,
            color: color || '#1677ff',
          }}>
            {icon}
          </div>
        )}
      </div>
    </Card>
  );
};

export default StatCard;
